import {
  TOGGLE_AVAILABILITY_ALERT_MODAL,
  SET_AVAILABILITY_ALERT,
} from 'Constants/redux';

function AvailabilityAlertReducer(
  state = {
    modalOpen: false,
    availabilityAlert: {},
    showOnly: false,
  },
  action
) {
  switch (action.type) {
    case TOGGLE_AVAILABILITY_ALERT_MODAL:
      return {
        ...state,
        modalOpen: !state.modalOpen,
        showOnly: action.showOnly
      };
    case SET_AVAILABILITY_ALERT:
      return {
        ...state,
        availabilityAlert: action.alert,
      };
    default:
      return state;
  }
}

export default AvailabilityAlertReducer;
